import { render, staticRenderFns } from "./voucherList.vue?vue&type=template&id=b72d1368&scoped=true"
import script from "./voucherList.vue?vue&type=script&lang=js"
export * from "./voucherList.vue?vue&type=script&lang=js"
import style0 from "./voucherList.vue?vue&type=style&index=0&id=b72d1368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d1368",
  null
  
)

export default component.exports